import React from 'react'
import { connect } from 'react-redux'
import { Button, Col, Divider, Form, Input, message, Spin, Upload } from 'antd'
import { ContactsOutlined, UploadOutlined } from '@ant-design/icons'

import '../../asset/less/NewPieces.css'
import ParnerProfileBusinessType from '../../component/contact/ParnerProfileBusinessTypeSelect'
import PartnerProfileBuildingTypeSelect from '../../component/contact/PartnerProfileBuildingTypeSelect'
import { uploadResume } from '../../api/amazonS3'
import PartnerProfileContactSelect from '../../component/contact/PartnerProfileContactSelect'
import { getAllArtistContact, getArtistPartnerProfile, patchPartnerProfile, postPartnerProfile } from '../../api/artistPartnerProfile'
import HttpError from '../../component/base/HttpError'
import FormButton from '../../component/base/FormButton'
import { withRouter } from 'react-router'
import { getFileNameByUrl } from '../../app/util'

@connect((state) => ({
  userId: state.user.info.id,
  artistId: state.user.info.artistId,
  email: state.user.info.email,
  role: state.user.info.role,
  artists: state.artist.artists
}))
class NewPartnerProfile extends React.Component {
  constructor(props) {
    super(props)
    this.formRef = React.createRef()
    this.state = {
      loading: false,
      contacts: []
    }
    this.is_new = props.new
  }

  getItemId = () => {
    let id = this.props.match.params.id
    if (!id) {
      const locationArry = this.props.location.pathname.split('/')
      id = parseInt(locationArry[locationArry.length - 1])
    }
    return id
  }

  componentDidMount() {
    this.setState({
      loading: true
    })
    let sanity_resume_url = (url) => {
      if (url) {
        if (url.startsWith('/home/ubuntu')) {
          let urls = url.split('/')
          url = 'https://revart.co/media/' + urls[urls.length - 1]
        }
        if (url === 'None') {
          return null
        }
      }
      return url
    }
    if (!this.is_new) {
      getArtistPartnerProfile(this.getItemId())
        .then((r) => {
          if (this.formRef.current) {
            let data = r.data
            data['brand_guideline'] = sanity_resume_url(data.brand_guideline)
              ? [
                  {
                    name: getFileNameByUrl(data.brand_guideline),
                    status: 'done',
                    url: sanity_resume_url(data.brand_guideline)
                  }
                ]
              : null
            data['floor_plan'] = sanity_resume_url(data.floor_plan)
              ? [
                  {
                    name: getFileNameByUrl(data.floor_plan),
                    status: 'done',
                    url: sanity_resume_url(data.floor_plan)
                  }
                ]
              : null
            this.formRef.current.setFieldsValue(data)
          }
          getAllArtistContact()
            .then((res) => {
              this.setState({
                contacts: res.data.results
              })
            })
            .catch((error) => {
              HttpError(error)
            })
        })
        .catch((error) => {
          HttpError(error)
        })
        .finally((v) => {
          this.setState({
            loading: false
          })
        })
    } else {
      getAllArtistContact()
        .then((res) => {
          this.setState({
            contacts: res.data.results
          })
        })
        .catch((error) => {
          HttpError(error)
        })
        .finally((v) => {
          this.setState({
            loading: false
          })
        })
    }
  }

  onFinish = (values) => {
    this.setState({
      loading: true
    })
    if (values['key_contact'] === undefined) {
      values['key_contact'] = []
    }
    if (values['other_contacts'] === undefined) {
      values['other_contacts'] = []
    }
    values['artist'] = this.props.artistId
    console.log(values)
    if (values.brand_guideline && values.brand_guideline.length > 0) {
      if (values.brand_guideline[0].response) values['brand_guideline'] = values.brand_guideline[0].response.url
      else values['brand_guideline'] = values.brand_guideline[0].url
    }
    if (values.floor_plan && values.floor_plan.length > 0) {
      if (values.floor_plan[0].response) values['floor_plan'] = values.floor_plan[0].response.url
      else values['floor_plan'] = values.floor_plan[0].url
    }
    if (this.is_new) {
      postPartnerProfile(values)
        .then((res) => {
          message.success('Add partner profile successfully').then((r) => {})
        })
        .catch((error) => {
          HttpError(error)
        })
        .finally(() => {
          this.setState({
            loading: false
          })
        })
    } else {
      patchPartnerProfile(this.getItemId(), values)
        .then((res) => {
          message.success('Update partner profile successfully').then((r) => {})
        })
        .catch((error) => {
          HttpError(error)
        })
        .finally(() => {
          this.setState({
            loading: false
          })
        })
    }
  }

  onFinishFailed = ({ values, errorFields, outOfDate }) => {
    this.setState({ validateError: errorFields })
    window.scrollTo(0, 0)
    window.scrollTop = 0
  }

  customRequestFile = (options) => {
    const { onError, onSuccess, file, onProgress } = options
    uploadResume(this.props.email, file, onSuccess, onError, onProgress)
  }

  render() {
    return (
      <Spin size='large' spinning={this.state.loading}>
        <Divider orientation='left'>{this.is_new ? 'Add' : 'Update'} partner profile</Divider>
        <Form
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14, offset: 2 }}
          colon={false}
          ref={this.formRef}
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <Form.Item
            name='business_type'
            label='Business type'
            rules={[
              {
                required: false,
                type: 'string',
                max: 100,
                min: 1
              }
            ]}
          >
            <ParnerProfileBusinessType />
          </Form.Item>
          <Form.Item
            name='business_name'
            label='Business name'
            rules={[
              {
                required: true,
                type: 'string',
                max: 100,
                min: 1
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='property_address'
            label='Property address'
            rules={[
              {
                required: false,
                type: 'string',
                max: 100,
                min: 1
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='company_name'
            label='Company name'
            rules={[
              {
                required: false,
                type: 'string',
                max: 100,
                min: 1
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='building_type'
            label='Building type'
            rules={[
              {
                required: false,
                type: 'string',
                max: 100,
                min: 1
              }
            ]}
          >
            <PartnerProfileBuildingTypeSelect />
          </Form.Item>
          <Form.Item name='key_contact' label='Key contact'>
            <PartnerProfileContactSelect artistId={this.props.artistId} contacts={this.state.contacts} />
          </Form.Item>
          <Form.Item name='other_contacts' label='Other contacts'>
            <PartnerProfileContactSelect artistId={this.props.artistId} contacts={this.state.contacts} />
          </Form.Item>
          <Form.Item
            name='brand_guideline'
            label='Brand guideline'
            valuePropName='fileList'
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) {
                return e
              }
              return e && e.fileList
            }}
          >
            <Upload listType='text' maxCount={1} customRequest={this.customRequestFile}>
              <Button icon={<UploadOutlined />}>Click to upload</Button>
            </Upload>
          </Form.Item>
          <Form.Item
            name='floor_plan'
            label='Floor plan'
            valuePropName='fileList'
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) {
                return e
              }
              return e && e.fileList
            }}
          >
            <Upload listType='text' maxCount={1} customRequest={this.customRequestFile}>
              <Button icon={<UploadOutlined />}>Click to upload</Button>
            </Upload>
          </Form.Item>
          <FormButton>
            <>
              <Col span={12} offset={6}>
                <Button block icon={<ContactsOutlined />} type='primary' size='large' htmlType={'submit'}>
                  {this.is_new ? 'Add' : 'Update'} Partner Profile
                </Button>
              </Col>
            </>
          </FormButton>
        </Form>
      </Spin>
    )
  }
}

export default withRouter(NewPartnerProfile)
